module.exports = __webpack_public_path__ + "img/uz.uz3721882.svg";